import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "552px",
  height: "552px",
  viewBox: "0 0 552 552",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<title>icon</title><defs><circle id=\"ec-f2090ee5-b5c3-4eee-9b44-a09d78649ef5-__path-1\" cx=\"256\" cy=\"256\" r=\"256\"></circle><filter x=\"-7.0%\" y=\"-4.7%\" width=\"114.1%\" height=\"114.1%\" filterUnits=\"objectBoundingBox\" id=\"ec-5e1172ac-5213-4dd9-88dd-e9b221549aa4-__filter-2\"><feOffset dx=\"0\" dy=\"12\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"></feOffset><feGaussianBlur stdDeviation=\"10\" in=\"shadowOffsetOuter1\" result=\"shadowBlurOuter1\"></feGaussianBlur><feComposite in=\"shadowBlurOuter1\" in2=\"SourceAlpha\" operator=\"out\" result=\"shadowBlurOuter1\"></feComposite><feColorMatrix values=\"0 0 0 0 0.497150808   0 0 0 0 0.495676549   0 0 0 0 0.495676549  0 0 0 0.5 0\" type=\"matrix\" in=\"shadowBlurOuter1\"></feColorMatrix></filter></defs>", 2),
    _createElementVNode("g", {
      id: "ec-c16658b5-2e1f-4e9d-b6f2-2b99f9471e1e-__icon",
      stroke: "none",
      "stroke-width": "1",
      fill: "none",
      "fill-rule": "evenodd",
      style: {},
      transform: "matrix(1, -0.012483, 0, 1, 0, 13.810069)"
    }, [
      _createElementVNode("g", { transform: "translate(20.000000, 8.000000)" }, [
        _createElementVNode("g", { id: "ec-14cec3b0-f238-4bc2-848b-4f8d02265da9-__Oval" }, [
          _createElementVNode("circle", {
            cx: "256",
            cy: "256",
            r: "256",
            transform: "matrix(1, 0, 0, 1, 0, 0)",
            fill: "black",
            "fill-opacity": "1",
            filter: "url(#ec-5e1172ac-5213-4dd9-88dd-e9b221549aa4-__filter-2)"
          }),
          _createElementVNode("circle", {
            stroke: "#E2E2E2",
            "stroke-width": "1",
            "stroke-linejoin": "square",
            fill: "#FEFEFE",
            "fill-rule": "evenodd",
            cx: "256",
            cy: "256",
            r: "255.5"
          })
        ]),
        _createElementVNode("text", {
          id: "ec-72e25c4c-784b-4cd7-95ca-cfffb3b71064-__8",
          "font-family": "Helvetica",
          "font-size": "460",
          "font-weight": "normal",
          "line-spacing": "460",
          fill: "#2D86D3",
          style: {"white-space":"pre"},
          y: "-86"
        }, [
          _createElementVNode("tspan", {
            x: "132",
            y: "383",
            style: {"font-size":"460px","word-spacing":"0px"}
          }, "8")
        ]),
        _createElementVNode("polyline", {
          id: "ec-7f27898a-42c3-44fc-a49e-0b9d711b5939-__Line-3",
          stroke: "#2D86D3",
          "stroke-width": "40",
          "stroke-linecap": "square",
          points: "140.352 405.64 160 438.389 352 438.389 371.878 405.64"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }